import React from 'react';
import { InitialType } from 'use-url-search-params';
import { Variant } from '../types/product';
import { User } from '../types/User';
import checkIfLoggedIn from '../utils/checkIfLoggedIn';
import { setRedirectAfterLoginOrSignup } from '../utils/localStorage';
import { saveWigStyle } from '../utils/metafieldService';

export function Alert({ message, messageContext, buttonText = 'OK', buttonAction, user, selectedVariant, searchParams, setSearchParams }: { message: string; messageContext: string; buttonText?: string; buttonAction: Function, user?: User, selectedVariant?: Variant, searchParams?: InitialType, setSearchParams?: any }): JSX.Element {

  function action(url: string) {
    const pathname = location.pathname;
    const search = location.search;

    buttonAction();
    setTimeout(() => {
      setRedirectAfterLoginOrSignup(pathname + search)
      location.href = url
    }, 100)
  }

  async function save() {
    if (!searchParams.styleId) {
      const styleId = await saveWigStyle({ user, sku: selectedVariant.sku, id: selectedVariant.id })
      setSearchParams({ styleId })
    }
    buttonAction();
  }

  function test() {
    buttonAction();
    location.href = '/';
  }

  return <>
    <div className="bg-black/[0.25] fixed inset-0 z-20" onClick={() => buttonAction()}></div>
    <div className="text-center fixed z-20 left-4 right-4 top-1/2 -translate-y-2/4 bg-white pt-12 px-4 pb-20 drop-shadow-cartItem max-w-[600px] mx-auto">
      <svg onClick={() => buttonAction()} className="cursor-pointer absolute top-5 right-5" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M0.509484 16.2458C0.314222 16.4411 0.314222 16.7577 0.509484 16.953C0.704746 17.1482 1.02133 17.1482 1.21659 16.953L8.99993 9.16961L16.7833 16.953C16.9785 17.1482 17.2951 17.1482 17.4904 16.953C17.6856 16.7577 17.6856 16.4411 17.4904 16.2458L9.70704 8.4625L16.7833 1.38627C16.9785 1.19101 16.9785 0.874424 16.7833 0.679162C16.588 0.4839 16.2714 0.4839 16.0762 0.679162L8.99993 7.7554L1.9237 0.679163C1.72844 0.483901 1.41185 0.483901 1.21659 0.679163C1.02133 0.874425 1.02133 1.19101 1.21659 1.38627L8.29283 8.4625L0.509484 16.2458Z"
          fill="black" />
      </svg>
      <h3 className={`${message !== '' ? 'mb-8' : ''} mx-auto ${messageContext ? 'max-w-[350px]' : '' }`}>{message}</h3>
      {messageContext &&
        <p className="peer:mt-5 max-w-[380px] mx-auto whitespace-pre-line">{messageContext}</p>
      }
      {message === 'You need to be signed in to save your tailored wig' ?
        <>
          <button className="bg-black text-white uppercase px-2 py-4 text-xl w-full mt-16 max-w-[480px] mx-auto block font-semibold" onClick={() => action('/account/login')}>Sign in</button>
          <a className="text-xs underline block mt-5" onClick={() => action('/account/register')}>Not a member? Create account</a>
        </>
        : message === 'Are you sure you want to exit tailoring your new wig?' ?
          <>
            {checkIfLoggedIn()
              ? <button className="bg-black text-white px-2 py-4 text-xl w-full mt-14 max-w-[480px] mx-auto font-semibold uppercase inline-block" onClick={() => save()}>save to profile</button>
              : <a className="bg-black text-white px-2 py-4 text-xl w-full mt-14 max-w-[480px] mx-auto font-semibold uppercase inline-block" onClick={() => action('/account/register')}>save to profile</a>
            }
            <button className="text-[20px] font-semibold underline mt-8 inline-block" onClick={() => test()}>Exit Tailor Your Wig</button>
          </>
          : <button className="bg-black text-white uppercase px-2 py-4 text-xl w-full mt-16 max-w-[480px] mx-auto font-semibold" onClick={() => buttonAction()}>{buttonText}</button>
      }
    </div>;
  </>
}
